module.exports = __webpack_public_path__ + "static/media/nuts_sesame.4107ed01.png";